import type React from 'react';

export interface SessionStatusIndicatorProps extends React.HTMLAttributes<HTMLDivElement> {
  status?: 'active' | 'idle' | 'offline';
  size?: 'sm' | 'md' | 'lg';
}

const statusClasses = {
  active: 'bg-success-border',
  idle: 'bg-text-disabled',
  offline: 'bg-text-disabled opacity-50'
};

const sizeClasses = {
  sm: 'w-1.5 h-1.5',
  md: 'w-2 h-2',
  lg: 'w-3 h-3'
};

export default function SessionStatusIndicator({
  status = 'active',
  size = 'md',
  className = '',
  ...props
}: SessionStatusIndicatorProps) {
  return (
    <div
      className={`rounded-full flex-shrink-0 ${sizeClasses[size]} ${statusClasses[status]} ${className}`}
      {...props}
    />
  );
}